export const epoch10 = () => {
  return Math.floor(Date.now() / 1000);
}